import { CommonModule } from '@angular/common';
import { Component, ViewChild, TemplateRef, inject } from '@angular/core';
import { ToastTypesEnum } from 'app/shared/enums/toast.enum';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-custom-toast',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './custom-toast.component.html',
  styleUrl: './custom-toast.component.scss'
})

export class CustomToastComponent extends Toast {
  override toastrService = inject(ToastrService);
  override toastPackage = inject(ToastPackage);
  types = ToastTypesEnum;

  constructor() {
    super(inject(ToastrService), inject(ToastPackage));
    setTimeout(() => {
      this.toastPackage.toastRef.close();
    }, 5000);

  }

  override remove() {
    this.toastPackage.toastRef.close();
  }
}
